export default __webpack_public_path__ + "static/Narcotic-5ea86701f058df610d40b9226bfdabed.png";